
import React from "react";

function RefreshIcon({ fill, ...restProps }) {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill={fill ?? ""}
      xmlns="http://www.w3.org/2000/svg"
      {...restProps}
    >
      <path
        d="M10.08 2.045A10.098 10.098 0 0 0 5.54 3.63a9.034 9.034 0 0 0-1.621 1.328 9.852 9.852 0 0 0-2.906 7.362c.071 2.119.739 4.008 2.02 5.72.397.53 1.272 1.424 1.767 1.807 1.442 1.114 2.988 1.777 4.8 2.06.568.088 2.06.099 2.64.019 1.971-.272 3.687-1.027 5.195-2.284a10.057 10.057 0 0 0 3.082-4.579c.068-.211.123-.462.123-.558 0-.377-.238-.75-.58-.909-.224-.104-.608-.101-.839.008-.299.14-.426.321-.617.877-.722 2.107-2.155 3.748-4.104 4.701a7.924 7.924 0 0 1-6.971.018 7.857 7.857 0 0 1-2.682-2.1c-1.745-2.086-2.296-4.987-1.444-7.598A8.137 8.137 0 0 1 6.62 5.309a9.168 9.168 0 0 1 1.882-.906 8.025 8.025 0 0 1 5.998.413c1.35.663 2.281 1.504 4.018 3.628l.438.536-2.108.02c-1.564.015-2.137.033-2.221.07a1.146 1.146 0 0 0-.499.446c-.091.156-.108.23-.108.484 0 .256.016.328.111.489.125.213.318.375.539.454.221.079 6.439.079 6.66 0 .221-.079.414-.241.539-.454l.111-.189V3.7l-.109-.186a1.01 1.01 0 0 0-1.742 0l-.109.186L20 5.386l-.02 1.686-.425-.506c-.915-1.09-1.756-1.945-2.415-2.457a10.076 10.076 0 0 0-7.06-2.064"
        fill-rule="evenodd"
        fill={fill ?? ""}
      />
    </svg>
  );
}

export default RefreshIcon;

